import styled from '@emotion/styled';
import Button from 'Stories/components/Button/Button';
import { black, teal } from 'Styles/colors';
import { Dialog, LinearProgress } from '@mui/material';
import { leaf } from 'Assets/img/screening-icons';
import { breakpoints } from 'Styles/theme';
import { Bookmark } from '../styles';

export const YouthNeedsWrapper = styled(Dialog)(
  ({ theme }) => `

  h1 {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    margin: 32px auto;
  }
  
  ${theme.breakpoints.up(breakpoints.TABLET)} {
    h1 {
      font-size: 24px;
    }
  }

  .MuiDialog-scrollPaper {
    background-image: linear-gradient(rgba(0, 0, 0, 0.68), rgba(0, 0, 0, 0.68)), url(${leaf}), linear-gradient(black, black);
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
    height: 100vh;
    width: 100vw;
  }

  .MuiDialog-paper {
    display: grid;
    grid-template-rows: 1fr 2fr 1fr;
    background-color: transparent;
    color: white;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  ${theme.breakpoints.up(breakpoints.TABLET)} {
    .MuiDialog-paper {
      grid-template-rows: 1fr 5fr 1fr;
    }
  }
  `,
);

export const YouthNeedsProgressBar = styled(LinearProgress)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 9px;
  margin-top: env(safe-area-inset-top);

  .MuiLinearProgress-bar {
    background-color: ${teal._400};
  }
`;

export const StyledBookmark = styled(Bookmark)`
  top: calc(9px + env(safe-area-inset-top));
`;

export const StyledNeedsForm = styled.div`
  .FormQuestion-root {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .FormQuestion-wrapper-question {
    background-color: ${(props) => (props.cardColor ? props.cardColor : '#565c89')};
    height: 395px;
    width: 285px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-radius: 4px;
    box-shadow: 0 12px 0 -10px grey, 0 16px 0 -12px lightgrey, 0 18px 0 -13px grey, 0 22px 0 -15px lightgrey,
      0 24px 0 -16px grey;
    margin-bottom: 24px;
  }

  .FormQuestion-question {
    font-size: 24px;
    font-weight: 700;
    margin: auto 24px;
  }

  .FormAnswer-root {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    margin: auto;
    padding: 0;
  }

  .MuiFormControlLabel-root {
    margin: 0;
  }

  .FormQuestion-answer-unchecked,
  .FormQuestion-answer-checked {
    height: 48px;
    width: 100px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
  }

  .FormQuestion-answer-unchecked {
    background-color: ${black._100};
    color: white;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: auto;
  justify-content: space-evenly;
  margin-bottom: 1em;
`;

export const LeafButton = styled(Button)`
  width: 100px;
  background-color: ${black._100};
  color: white;
`;
